
import { get } from 'lodash';
import { constructPaginationPayload } from 'utilities/pagination';
import { CONFIGURE_PAGINATION } from 'actions/actionTypes';

export const pagination = store => next => (action) => {
  const { type } = action;
  const fingerprint = get(action, 'meta.fingerprint', null);
  if (!fingerprint) {
    next(action);
    return;
  }
  if (type === CONFIGURE_PAGINATION) {
    next(action);
    return;
  }
  const paginationSettings = store.getState().pagination[fingerprint]; // @todo : use constant
  if (paginationSettings) {
    const newPayload = constructPaginationPayload(paginationSettings);
    const newAction = Object.assign(action, {
      payload: {
        ...action.payload,
        ...newPayload
      }
    });
    next(newAction);
    return;
  }
  next(action);
};

export default pagination;
